<template>
  <div class="noSearcResult">لا توجد نتائج</div>
</template>

<style lang="scss" scoped>
    .noSearcResult {
        width: 100%;
        text-align: center;
        height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4rem 2rem;
    }
</style>
